import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  ENDPOINT_GET_INTERVIEW_JOHARI,
  ENDPOIfNT_PEGAR_DADOS_INTERVIEW_JOHARI,
  ENDPOIfNT_PEGAR_DADOS_JOHARI,
  ENDPOIfNT_SALVAR_JOHARI,
} from './constants';

export function useJohariService() {
  const { backendGet, backendPost } = Sebrae.useBackend();

  const getJohariData = React.useCallback(
    () => backendGet(`${ENDPOIfNT_PEGAR_DADOS_JOHARI}`),
    [backendGet],
  );

  const getJohariInterviewData = React.useCallback(
    (id) => backendGet(`${ENDPOIfNT_PEGAR_DADOS_INTERVIEW_JOHARI}/${id}`),
    [backendGet],
  );

  const getJohariInterviewDataPublic = React.useCallback(
    (module, cpf) =>
      backendGet(
        `${ENDPOINT_GET_INTERVIEW_JOHARI}/module/${module}/cpf/${cpf}/last`,
      ),
    [backendGet],
  );

  const saveJohari = React.useCallback(
    (data = {}) => {
      return backendPost(`${ENDPOIfNT_SALVAR_JOHARI}`, data);
    },
    [backendPost],
  );

  return {
    getJohariData,
    getJohariInterviewData,
    saveJohari,
    getJohariInterviewDataPublic,
  };
}
